<template>
<div container--fluid>
    <v-layout>
        <TeamNominationModule></TeamNominationModule>
    </v-layout>
</div>
</template>

<script>
import TeamNominationModule from '@modules/teamnomination/index.vue';

export default {
    name: 'teamnomination',
    components: {
        TeamNominationModule,
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
